// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1bV-6","modalFooterButton":"ModalNotes_modalFooterButton__3lphA"};